import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";


import { CallListComponent } from "./call-list.component";
import { NgxPaginationModule } from "ngx-pagination";
import { PipeModule } from "app/pipes/pipe.module";

@NgModule({
  declarations: [
    CallListComponent
  ],
  exports: [
    CallListComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxPaginationModule,
    PipeModule
  ]
})
export class CallListModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/call/list/call-list.module.ts